import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {AI_TEXT_TO_IMAGE_EMPTY_VISUAL_ASSET_PATH} from '@Components/text-to-image-grid/text-to-image-grid.types';
import {PosterEditorTestId} from '@/test-ids/poster-editor-test-id';
import styles from './ai-image-upsell.module.scss';

export function AiImageUpsell(): ReactElement {
  const featureName = window.PMW.PREMIUM_ONLY_FEATURE_NAME_TEXT_TO_IMAGE_PANEL;

  useEffect(() => {
    window.PMW.setCookieForUpsellDialogShown(featureName);
  }, [featureName]);

  const onCtaClick = (): void => {
    window.PMW.premiumDialogs.openPricingDialog(featureName);
  };

  return (
    <div className={styles.aiImageUpsell} data-testid={PosterEditorTestId.AI_IMAGE_UPSELL}>
      <img alt="" aria-hidden className={styles.aiImageUpsellGraphic} src={getAssetUrl(AI_TEXT_TO_IMAGE_EMPTY_VISUAL_ASSET_PATH)} />
      <Text bold className={`ct-neutral-primary ${styles.aiImageUpsellTitle}`} size={TextSize.LG} val={window.i18next.t('pmwjs_create_the_perfect_visual')} />
      <Text className={`ct-neutral-secondary ${styles.aiImageUpsellDescription}`} size={TextSize.MD} val={window.i18next.t('pmwjs_ai_image_upsell_description')} />
      <Button
        customClasses={styles.aiImageUpsellCta}
        icon="icon-crown"
        iconPlacement={IconPlacement.LEFT}
        onClick={onCtaClick}
        size={Size.SMALL}
        text={window.i18next.t('pmwjs_upgrade_to_premium')}
        type={Type.PREMIUM}
      />
    </div>
  );
}
